import React from 'react';
import 'devextreme/dist/css/dx.light.css';
import AboutChart from './../../components/AboutChart';
import AboutOrg from './../../components/AboutOrg';


const AboutUsDetail = ({res}) => {
    const myDomain = "src=\"" + process.env.REACT_APP_BASE_URL;
    const getImagesWithAbsolutePath = (text, absolutePathPrefix) => {
        if (!text) return ''
        const regex =  new RegExp(`(?:src=\"\/*)+(.*?)`, "g")
        return text.replace(regex,  absolutePathPrefix + '/$1')
    }
    
   

    return (
        <>
        
        <div>
            
        {
                res.aboutUs[0].hasColumnizedStructure ?
                      
                                       <div className={`product-content-wrapper`}>
                                           <div className="row">
                                               {
                                                   res.aboutUs[0].licenceAndImage.contentItems.map(i => 
                                                       // console.log(i)
                                                       <div className="card-container_ w-50" style={{textAlign: 'left'}}>
                                                           <div className="card u-clearfix_" style={{flexDirection:"row", height:"100%", minHeight: '400px', border:"none"}}>
                                                               <div className="card-body_">
                                                                   <span className="card-author_ subtle_">{i.displayText}</span>
                                                                   <span className="card-description_ subtle_" dangerouslySetInnerHTML={{__html: i.htmlBody.html}}/>
                                                                 
                                                               </div>
                                                               <div className="card-media_">
                                                                  
                                                                       <img src={process.env.REACT_APP_BASE_URL + i.licenceImage.urls[0]} alt="" />
                                                                   
                                                               </div>
                               
                                                           </div>
                                                           <div className="card-shadow_"></div>
                                                       </div>
                                                       
                                                       )
                       
                                               }
                                              
                                           </div>
                                       </div>
                                  
                :
                <div style={{padding:"2% 10%", lineHeight:"40px"}} dangerouslySetInnerHTML={{__html:getImagesWithAbsolutePath(res.aboutUs[0].htmlBody.html, myDomain)}}></div>
            }
            
               
           
            {
                res.aboutUs[0].aboutUsChart.contentItems && res.aboutUs[0].aboutUsChart.contentItems[0] && res.aboutUs[0].aboutUsChart.contentItems[0].__typename === "AboutUsChart" ? <AboutChart chartData={res.aboutUs[0].aboutUsChart.contentItems}/> : null
                
            }
            {
                res.aboutUs[0].aboutUsChart.contentItems && res.aboutUs[0].aboutUsChart.contentItems[0] &&  res.aboutUs[0].aboutUsChart.contentItems[0].__typename === "OrganizationNode" ? <AboutOrg chartData={res.aboutUs[0].aboutUsChart.contentItems}/> : null
            }
        </div>
        <br/>
        <br />
        <br />
        </>
        
    );
};

export default AboutUsDetail;
